import { styled } from '@mui/material/styles';
import COLORS from '../../styles/theme/colors';

export const FormItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  marginBottom: theme.spacing(1.5),

  '& .MuiInputLabel-root': {
    fontSize: 14,
    color: COLORS.textSecondColor,
    marginBottom: theme.spacing(0.5),
  },

  '& .MuiOutlinedInput-root': {
    fontSize: 14,
    borderRadius: 8,
    color: COLORS.textSecondColor,

    '& input': {
      borderRadius: 8,
      color: COLORS.textSecondColor,
      padding: theme.spacing(1.3, 2),
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: 1
      }
    }
  }
}));
